import './checkbox.scss';

const Checkbox = (props) => {
  const {
    value,
    label,
    onCheckboxChange = () => {},
    updateDropButtonState = () => {}
  } = props;

  const handleChange = (e) => {
    onCheckboxChange(e);
    updateDropButtonState(e);
  };

  return (
    <label className={'checkbox'}>
      <input
        className="checkbox__input"
        type="checkbox"
        value={value}
        onChange={handleChange}
      />
      <span className="checkbox__visual"></span>
      <span className="checkbox__label">{label}</span>
    </label>
  );
};

export default Checkbox;
